import { render, staticRenderFns } from "./FreeeWaitingModal.vue?vue&type=template&id=213a9e80&"
import script from "./FreeeWaitingModal.vue?vue&type=script&lang=js&"
export * from "./FreeeWaitingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports